import React, { useEffect } from 'react';

import { useSelector } from 'react-redux';

import { ThemeProvider } from '@mui/material/styles';
import { CssBaseline, StyledEngineProvider } from '@mui/material';

// routing
import Routes from 'routes';

// defaultTheme
import themes from 'themes';


// project imports
import NavigationScroll from 'layout/NavigationScroll';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { getCourtTypeObj, setCourtTypeObj } from 'helper/LocalStorage';
import { getSportCourtTypes } from 'services/placeServices';

// ==============================|| APP ||============================== //

const App = () => {
  const customization = useSelector((state) => state.customization);
  if (window.location.href.includes('https')) {
    console.log = function no_console() { };
  }

  useEffect(() => {
    loadCourtType()
  }, [])

  const loadCourtType = async () => {
    let { data, error } = await getSportCourtTypes({})
    if (data) {
      let newObj = {
        "all_court": "All Court"
      }
      for (let i = 0; i < data.length; i++) {
        newObj[data[i].courtType] = data[i].name
      }
      setCourtTypeObj(newObj)
      if (!getCourtTypeObj) { window.location.reload() }
    }
  }

  return (
    <StyledEngineProvider injectFirst>
      <ToastContainer />
      <ThemeProvider theme={themes(customization)}>
        <CssBaseline />
        <NavigationScroll>
          <Routes />
        </NavigationScroll>
      </ThemeProvider>
    </StyledEngineProvider>
  );
};

export default App;
